import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

const AddIcon = (props: SVGProps) => {
  return <SpriteIcon spriteId="plus" {...props} />;
};

export { AddIcon };
